import map from 'lodash/fp/map'
import flow from 'lodash/fp/flow'
import assign from 'lodash/fp/assign'
import keys from 'lodash/fp/keys'
import intersection from 'lodash/fp/intersection'
import prop from 'lodash/fp/prop'
import propEq from 'lodash/fp/propEq'
import reduce from 'lodash/fp/reduce'

const BOOLEAN_KEYS = [
  'compatibility.enable',
  'keycloakModeEnable',
  'needCustomizedEmails',
  'disableSignInLink',
  'hasCustomizedWaiver',
  'ignoreActiveWaiver',
  'needCustomizedEmails',
  'suppressActiveWaiver',
  'useCustomizeWaiver',
  'ignoreCOPPA',
  'isExternal',
]

const NUMERIC_KEYS = []

const parse = (parser, keysToParse) => source => ({
  ...source,
  ...flow(
    keys,
    intersection(keysToParse),
    map(key => ({
      [key]: parser(source)(key),
    })),
    reduce(assign, {}),
  )(source),
})

const booleanParser = source => key => propEq(key, 'true')(source)

const numberParser = source => key => Number(prop(key)(source))

export default ({
  url,
  redirectUrl,
  waiverInfos,
  settings,
  ...rest
}) => flow(
  parse(booleanParser, BOOLEAN_KEYS),
  parse(numberParser, NUMERIC_KEYS),
)({
  config: {
    ...flow(
      parse(booleanParser, BOOLEAN_KEYS),
      parse(numberParser, NUMERIC_KEYS),
    )(settings),
    redirectUrl,
    url,
    waiverInfos,
  },
  ...rest,
})
